import { render, staticRenderFns } from "./DrawPart.vue?vue&type=template&id=494c61fe&scoped=true&"
import script from "./DrawPart.vue?vue&type=script&lang=ts&"
export * from "./DrawPart.vue?vue&type=script&lang=ts&"
import style0 from "./DrawPart.vue?vue&type=style&index=0&id=494c61fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494c61fe",
  null
  
)

export default component.exports